module.exports = __webpack_public_path__ + "img/proses_persiapan.6d01f5a1.png";